var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"form-control input_color",attrs:{"type":"date"},domProps:{"value":_vm.value},on:{"input":_vm.updateDate}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }